import './App.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { AppProvider } from 'contexts/AppContext'
import { ProgramProvider } from 'ui/hooks/useProgram'
import AllRoutes from 'routes/AllRoutes'
import ErrorBoundary from 'pages/ErrorPage'
import { ToastContainer } from 'react-toastify'
import { GrowthBookProvider } from '@growthbook/growthbook-react'
import { NotificationProvider } from 'ui/components/Notifications/NotificationProvider'
import CookieDisclaimer from 'ui/components/CookieDisclaimer/CookieDisclaimer'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import AutoLogoffManager from 'ui/components/AutoLogoffManager'
import { UnsavedGuardProvider } from 'contexts/UnsavedGuard'
import { growthbook } from 'growthbook'
import { PlanningYearProvider } from 'contexts/PlanningYearContext'
import { PotatoTypeProvider } from 'contexts/PotatoTypeContext'
import { oktaAuthObject } from './oktaConfig'

// Adjust the import path
const queryClient = new QueryClient()

function App() {
  const navigate = useNavigate()
  // Correctly defining restoreOriginalUri callback
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin))
  }

  return (
    <ErrorBoundary fallback={<div />}>
      <Security oktaAuth={oktaAuthObject} restoreOriginalUri={restoreOriginalUri}>
        <AutoLogoffManager />
        <GrowthBookProvider growthbook={growthbook}>
          <PlanningYearProvider>
            <ProgramProvider>
              <AppProvider value>
                <QueryClientProvider client={queryClient}>
                  <PotatoTypeProvider>
                    <NotificationProvider>
                      <UnsavedGuardProvider>
                        <div data-testid="toast-container">
                          <ToastContainer
                            position="top-right"
                            autoClose={8000}
                            hideProgressBar={false}
                            closeButton
                            style={{ zIndex: 1300 }}
                          />
                        </div>
                        <CookieDisclaimer />
                        <AllRoutes />
                      </UnsavedGuardProvider>
                    </NotificationProvider>
                  </PotatoTypeProvider>
                </QueryClientProvider>
              </AppProvider>
            </ProgramProvider>
          </PlanningYearProvider>
        </GrowthBookProvider>
      </Security>
    </ErrorBoundary>
  )
}

export default App
